var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.918 12l.965 1.188L14.5 7.5 9.883 1.81l-.965 1.19 2.964 3.65H.5v1.697h11.382L8.918 12z","fill":"#4541E3"}));
}

Arrow.defaultProps = {"viewBox":"0 0 15 15","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
